export default __webpack_public_path__ + "static/media/tutorialMomo-3.13.8e8fad81.png";